import { useState } from "react";
const sceneImage = "/images/scene-03.png";

function Scene03({ onNext }) {
  const [scanning, setScanning] = useState(false);

  const handleScan = () => {
    if (scanning) return;

    setScanning(true);

    setTimeout(() => {
      onNext();
    }, 7000);
  };

  return (
    <>
      {/* Background */}
      <img
        src={sceneImage}
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
      />

      {/* Header */}
      <div className="absolute inset-x-4 top-7 z-10 text-center">
        <h1 className="font-playful text-[2.4rem] font-bold leading-none text-white drop-shadow-[0_4px_4px_rgba(0,0,0,0.45)]">
          ONE LAST STEP...
        </h1>

        <div className="mx-auto mt-3 w-fit rounded-2xl border-2 border-[#8a5a32] bg-[#f5d49a] px-5 py-2 shadow-[0_4px_0_#8a5a32]">
          <p className="font-playful text-xl font-bold text-[#4b3024]">
            VERIFY AINI'S FINGERPRINT
          </p>
        </div>
      </div>

      {/* Invisible Fingerprint Button */}
      <button
        onClick={handleScan}
        disabled={scanning}
        aria-label="Scan fingerprint"
        className="absolute left-1/2 top-1/2 z-20 h-32 w-32 -translate-x-1/2 -translate-y-1/2 rounded-full bg-transparent"
      />

      {/* Fingerprint Scanner */}
      {scanning && (
        <div className="pointer-events-none absolute left-1/2 top-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
          <div className="relative flex h-28 w-28 items-center justify-center">
            {/* Outer glow */}
            <div className="absolute inset-0 animate-ping rounded-full border border-white/30" />

            {/* Spinner */}
            <div className="absolute h-24 w-24 animate-spin rounded-full border-[4px] border-white/20 border-t-white border-r-white/80" />

            {/* Inner ring */}
            <div className="absolute h-16 w-16 rounded-full border-2 border-white/50" />

            {/* Scanning dot */}
            <div className="absolute h-3 w-3 animate-pulse rounded-full bg-white shadow-[0_0_18px_rgba(255,255,255,0.95)]" />
          </div>

          <p className="mt-4 text-center font-playful text-lg font-semibold tracking-wide text-white drop-shadow-lg">
            SCANNING...
          </p>
        </div>
      )}
    </>
  );
}

export default Scene03;
